import React, { Component } from "react";
import { Route, NavLink, Link, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../../utils/router";

import { withRequest } from "../../../utils/request";
import Loader from "../../general/Loader";
import Edit from "./Edit";
import { getLink } from "../../../utils/helpers";

class Layout extends Component {
    state = {
        tutor: {},
        loading: true,
    };

    componentDidMount() {
        this.getTutor();
    }

    getTutor = async (url = null) => {
        const id = this.props.match.params.id;
        url = url ? url : "academico/padres-tutores/" + id;
        const tutor = await this.props.request(url);

        if (tutor.success) {
            this.setState({
                tutor: tutor.data,
                loading: false,
            });
        }
    };

    render() {
        const { loading, tutor } = this.state;

        if (loading) {
            return <Loader />;
        }

        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/academico/padres-tutores')}>&laquo; Volver al listado</Link>
                    <h1 className='page-title'>
                        {tutor.foto && (
                            <span className='page-title-foto'>
                                <img
                                    src={tutor.foto}
                                    alt={tutor.codigo}
                                />
                            </span>
                        )}
                        {tutor.nombreCompleto}
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-3 page-sidebar'>
                        <ul className='list-unstyled page-sidebar__menu'>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/academico/padres-tutores/${tutor.id}/informacion`
                                    )}
                                    end
                                    className='nav-link'>
                                    Información General
                                </NavLink>
                                <NavLink
                                    to={getLink(
                                        `/academico/padres-tutores/${tutor.id}/estudiantes`
                                    )}
                                    end
                                    className='nav-link'>
                                    Estudiantes
                                </NavLink>
                                <NavLink
                                    to={getLink(
                                        `/academico/padres-tutores/${tutor.id}/pagos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Historial Pagos
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-8 offset-1'>
                        <Routes>
                            <Route
                                path='informacion'
                                element={<RenderRoute render={(props) => (
                                    <Edit {...props} tutor={tutor} />
                                )} />}
                            />
                        </Routes>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(Layout));
